module.exports = __webpack_public_path__ + "img/chevron-down-new.039ea40e.svg";